"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.refreshApplicationState = void 0;
var constants_1 = require("shared/store/actions/websocket/constants");
var typesafe_actions_1 = require("typesafe-actions");
exports.refreshApplicationState = (0, typesafe_actions_1.createStandardAction)(constants_1.REFRESH_APPLICATION_STATE)();